import { useApolloClient } from '@apollo/client'
import { getOperationName } from '@apollo/client/utilities'
import { ReferencesProductTableRows_PriceAndStockDocument } from '@gql-generated/graphql'
import { useCallback } from 'react'

const ReferencesProductTableRows_PriceAndStockOperationName = getOperationName(
  ReferencesProductTableRows_PriceAndStockDocument,
)

function hasValidReferencesVariables(variables: Record<string, unknown> | undefined): boolean {
  if (!variables) {
    return false
  }

  const references = variables.references

  return (
    Array.isArray(references) &&
    references.length > 0 &&
    references.every((reference) => typeof reference === 'string' && reference.length > 0)
  )
}

export function useRefreshReferencesProductTableRowsPriceAndStock() {
  const client = useApolloClient()

  return useCallback(() => {
    if (!ReferencesProductTableRows_PriceAndStockOperationName) {
      console.error('Failed to refetch query ReferencesProductTableRowsPriceAndStock_PriceAndStock')
    } else {
      client.refetchQueries({
        include: [ReferencesProductTableRows_PriceAndStockOperationName],
        onQueryUpdated(observableQuery) {
          if (observableQuery.queryName === ReferencesProductTableRows_PriceAndStockOperationName) {
            if (!hasValidReferencesVariables(observableQuery.variables)) {
              console.error(
                'Failed to refetch query ReferencesProductTableRowsPriceAndStock_PriceAndStock: invalid variables',
                observableQuery.variables,
              )

              return false
            }

            return true
          }

          return true
        },
      })
    }
  }, [client])
}
